import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InactivityHandler from "@components/common/funtion/SessionInvalidator/InactivityHandler";
import { BeoConfirmDialouge, BeoToast } from "@components/common/view";
import Spinner from "@components/others/Spinner";
import { useBEOController } from "@context/BeoContext";
import { useGlobalLoading } from "@context/BeoLoadingContext";
import Footer from "@pages/common/footer/Footer";
import { setConfirmDialogCallback } from "@services/common/ConfirmDialogService";
import { setToastRef } from "@services/ToastService";
import { useEffect, useRef, useState } from "react"; // Explicitly import React
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/css/common/style.css";
import { getUserRole } from "@utils/auth";
var BaseLayout = function (_a) {
    var children = _a.children, handleLogout = _a.handleLogout;
    var context = useBEOController()[0];
    var isLoading = useGlobalLoading().isLoading;
    var navigate = useNavigate();
    var location = useLocation();
    var toastRef = useRef(null);
    var _b = useState(null), confirmConfig = _b[0], setConfirmConfig = _b[1];
    var _c = useState(false), visible = _c[0], setVisible = _c[1];
    useEffect(function () {
        setToastRef(toastRef);
        setConfirmDialogCallback(function (config) {
            setConfirmConfig(config);
            setVisible(true);
        });
    }, []);
    useEffect(function () {
        var _a;
        if (getUserRole() === "ADMIN") {
            return;
        }
        // Get the list of roles assigned to the current user from context
        var roles = (_a = context === null || context === void 0 ? void 0 : context.userInfo) === null || _a === void 0 ? void 0 : _a.roles;
        // Log the current pathname for debugging
        console.log("location.pathname  " + location.pathname);
        // Check if the user has access to the current route
        if (!(roles === null || roles === void 0 ? void 0 : roles.find(function (role) {
            // Log each role's pathname for debugging
            console.log("role.pathname  " + role.pathname);
            // Return true if the current route includes the role's pathname
            return location.pathname.includes(role.pathname);
        }))) {
            // If no matching role is found, redirect user to "unauthorized" page
            navigate("/unauthorized");
        }
    }, [location.pathname]);
    return (_jsxs("div", { className: "min-h-screen w-full bg-cover bg-no-repeat bg-center bg-fixed dark:bg-black", children: [_jsx(BeoToast, { id: "toast", position: "top-right", ref: toastRef }), _jsx(BeoConfirmDialouge, { id: "confirm-dlg-header", visible: visible, onHide: function () {
                    var _a;
                    setVisible(false);
                    (_a = confirmConfig === null || confirmConfig === void 0 ? void 0 : confirmConfig.reject) === null || _a === void 0 ? void 0 : _a.call(confirmConfig);
                }, message: (confirmConfig === null || confirmConfig === void 0 ? void 0 : confirmConfig.message) || "", header: (confirmConfig === null || confirmConfig === void 0 ? void 0 : confirmConfig.header) || "Confirmation", icon: (confirmConfig === null || confirmConfig === void 0 ? void 0 : confirmConfig.icon) || "pi pi-exclamation-triangle", accept: confirmConfig === null || confirmConfig === void 0 ? void 0 : confirmConfig.accept, reject: confirmConfig === null || confirmConfig === void 0 ? void 0 : confirmConfig.reject, acceptClassName: confirmConfig === null || confirmConfig === void 0 ? void 0 : confirmConfig.acceptClassName, defaultFocus: confirmConfig === null || confirmConfig === void 0 ? void 0 : confirmConfig.defaultFocus, style: { width: "25vw" }, breakpoints: { "1100px": "75vw", "960px": "100vw" } }), isLoading && (_jsx("div", { className: "fixed inset-0 bg-black/30 backdrop-blur-xs flex items-center justify-center z-[9999]", children: _jsx(Spinner, {}) })), _jsx(InactivityHandler, { onLogout: handleLogout }), children, _jsx(Footer, {})] }));
};
export default BaseLayout;
